module.exports = __webpack_public_path__ + "img/11.f65fe35d.png";